import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CheckIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4167 0.25C11.0833 -0.0833333 10.5833 -0.0833333 10.25 0.25L4 6.5L1.41667 3.91667C1.08333 3.58333 0.583333 3.58333 0.25 3.91667C-0.0833333 4.25 -0.0833333 4.75 0.25 5.08333L3.41667 8.25C3.58333 8.41667 3.75 8.5 4 8.5C4.25 8.5 4.41667 8.41667 4.58333 8.25L11.4167 1.41667C11.75 1.08333 11.75 0.583333 11.4167 0.25Z"
        fill="currentColor"
      />
    </svg>
  )
})

CheckIcon.displayName = 'CheckIcon'
